/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentGCSEquipments.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for GCS Equipment API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Monday, April 01, 2019 - 08:21:08 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      04/01/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const GCSEquipments = {
    all: (rigid, sectionid, parentid) => requests.get(`/GCSEquipments?rigid=${rigid}&sectionid=${sectionid}&parentid=${parentid}`),
    get: equipmentid => requests.get(`/GCSEquipment/${equipmentid}`),
    create: gcsequipment => requests.post(`/GCSEquipments`, gcsequipment),
    update: (equipmentid, gcsequipment) => requests.put(`/GCSEquipment/${equipmentid}`, gcsequipment),
    delete: equipmentid => requests.del(`/GCSEquipment/${equipmentid}`),
};

export const GCSEquipmentPath = {
    get: equipmentid => requests.get(`/GCSEquipmentPath/${equipmentid}`),
}


// WEBPACK FOOTER //
// ./src/agents/agentGCSEquipments.js